import React, { useState, useEffect } from 'react';

const SnackBar = ({ message, type }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (message) {
            setVisible(true);
            const timer = setTimeout(() => setVisible(false), 2000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    if (!message) return null;

    const style = {
        position: 'fixed',
        bottom: '16px',
        right: '5%',
        transform: 'translateX(-50%)',
        backgroundColor: type === 'success' ? '#4caf50' : '#f44336',
        color: 'white',
        padding: '16px',
        borderRadius: '4px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        zIndex: 9999,
        transition: 'opacity 0.5s ease-in-out',
        maxWidth: '400px',
        margin: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
    };

    return <div style={style}>{message}</div>;
};

export default SnackBar;
